import { PocAssistiveText } from 'commons/components/components-wrapper/poc-assistive-text.component';
import { PocInput } from 'commons/components/components-wrapper/poc-input.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const DeviceConfigStatusTrackingInput = styled(PocInput)`
    max-width: ${owcTheme['one-sizer-base-250']};
`;

export const DeviceConfigStatusTrackingAssistiveText = styled(PocAssistiveText)`
    pointer-events: auto;
`;

export const DeviceConfigStatusTrackingRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    align-items: center;
    justify-content: space-between;

    &.flex-end {
        justify-content: flex-end;
    }
`;

export const DeviceConfigStatusTrackingRowTypography = styled(PocTypography).attrs({ variant: 'subtitle1' })`
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

export const DeviceConfigStatusTrackingRightCol = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
    align-self: flex-end;
    width: fit-content;
`;

export const DeviceConfigStatusTrackingDescriptionCard = styled(PocTypography).attrs({ variant: 'body2' })`
    color: ${owcTheme['one-color-foreground-intensity-medium']};
`;
